import React from 'react'

const GameSlider = ({ image, title, link }) => (
    <div className='game-item'>
        <img src={image} alt='' />
    </div>
)

export default GameSlider
